module.exports = __webpack_public_path__ + "img/24_3.d5093fa1.png";